const SubjectActionTypes = {
  SET_SUBJECTS: 'SET_SUBJECTS',
  REMOVE_SUBJECT: 'REMOVE_SUBJECT',
};

export default SubjectActionTypes;
